<div style="text-align-last: center;">
    <h1>{{'Safety Observation Search' | translate | async}}</h1>
</div>


<mat-card style=" margin-left: 2%;margin-right: 2%;">
    <div class="search-options"
        style="min-width: 150px;width: 100%;display: flex;justify-content: space-between;flex-wrap: wrap;">

        <mat-form-field class="header-form-full-width">
            <input matInput [matDatepicker]="startDatePicker" placeholder="{{'Start Date' | translate | async}}" [(ngModel)]="startDate">
            <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #startDatePicker></mat-datepicker>
        </mat-form-field>

        

        <mat-form-field class="header-form-full-width">
            <mat-select id="select-question" (selectionChange)="SiteChange($event)" placeholder="{{'All States' | translate | async}}" [(ngModel)]="selectedState" ngDefaultControl
                multiple>
                <mat-option [value]="state.ID" *ngFor="let state of StateList">
                    {{state.SideCode}} - {{state.StateName}}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field class="header-form-full-width">
            <mat-select id="select-workArea" placeholder="{{'Select Work Area' | translate | async}}" [(ngModel)]="selectedWorkArea"
                ngDefaultControl multiple>
                <mat-option [value]="work.ID" *ngFor="let work of WorkAreaList">
                    {{work.WorkAreaName}}
                </mat-option>
            </mat-select>
        </mat-form-field>
        
        <mat-form-field class="header-form-full-width">
            <mat-select id="select-category" placeholder="{{'Select Category' | translate | async}}" [(ngModel)]="selectedCategory"
                ngDefaultControl multiple>
                <mat-option [value]="cat.ID" *ngFor="let cat of CategoryList">
                    {{cat.CategoryName}}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field class="header-form-full-width">
            <input 
            matInput 
            [matDatepicker]="endDatePicker"
             placeholder="{{'End Date' | translate | async}}" 
             [(ngModel)]="endDate">
            <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #endDatePicker></mat-datepicker>
        </mat-form-field>

        <mat-form-field class="header-form-full-width">
            <mat-select id="select-department" placeholder="{{'Select Department' | translate | async}}" (selectionChange)="DepChange($event)"  [(ngModel)]="selectedDepartment"
                ngDefaultControl multiple>
                <mat-option [value]="dep.ID" *ngFor="let dep of DepartmentList">
                    {{dep.DepartmentName}}
                </mat-option>
            </mat-select>
        </mat-form-field>

        

        <mat-form-field class="header-form-full-width">
            <mat-select id="select-contractor" placeholder="{{'Select Contractor' | translate | async}}" [(ngModel)]="selectedContractor"
                ngDefaultControl multiple>
                <mat-option [value]="contrcator.ContractorCompanyName" *ngFor="let contrcator of ContractorList">
                    {{contrcator.ContractorCompanyName}}
                </mat-option>
            </mat-select>
        </mat-form-field>

        

        <mat-form-field class="header-form-full-width">
            <mat-select id="select-question" placeholder="{{'Select Question' | translate | async}}" [(ngModel)]="selectedQuestion"
                ngDefaultControl multiple>
                <mat-option [value]="q.ID" *ngFor="let q of QuestionList">
                    {{q.QuestionName}}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field class="header-form-full-width">
            <mat-select id="select-question" placeholder="{{'Supplier' | translate | async}}" [(ngModel)]="selectedCustomer"
                ngDefaultControl multiple>
                <mat-option [value]="customer.Id"  *ngFor="let customer of _dropDownLists.customerList">
                    {{customer.Title}}
                </mat-option>
            </mat-select>
        </mat-form-field>
        
  

        <div class="header-form-full-width">

        </div>




    </div>

    <div style="display: flex;">
        <div class="search-options-cell" style="display: flex;    margin-left: 7px;">

            <mat-checkbox class="example-margin" [(ngModel)]="FollowUpReq"> {{'Follow Up Required' | translate | async}}</mat-checkbox>
            <mat-checkbox class="example-margin" [(ngModel)]="FollowUpComp">{{"Follow Up Completed" | translate | async}}</mat-checkbox>
            <mat-checkbox class="example-margin" [(ngModel)]="OnlyUnsafe">{{'Only Unsafe' | translate | async}}</mat-checkbox>
            <mat-checkbox class="example-margin" [(ngModel)]="ExcludeNA">{{"Exclude N/A" | translate | async}}</mat-checkbox>
            <mat-checkbox class="example-margin" [(ngModel)]="OnlyInsp">{{'Only Inspections' | translate | async}}</mat-checkbox>
        </div>

        <div class="search-options-cell">
            <div style="display: flex;flex-direction: row;justify-content: flex-end;">
                <a class="button" (click)="ResetFields()">
                    <span class="button__text">{{"Reset" | translate | async}}</span></a>
                <a class="button button--primary" (click)="SearchInspections()">
                    <span class="button__text"> {{"Search" | translate | async}}</span>
                    <i class="material-icons button__icon">search</i>
                </a>
            </div>
        </div>

    </div>
</mat-card>

<div class="row" style="margin-top: 1%;text-align: center;">
    <div class="marg">
        <div class="column">
            <mat-checkbox class="example-margin" [(ngModel)]="shwDep" [checked]="shwDep"
                (change)="changeCheckbox(shwDep, 'Department',1 )">{{"Show Department" | translate | async}}</mat-checkbox>
            <mat-checkbox class="example-margin" [(ngModel)]="shwWA" [checked]="shwWA"
                (change)="changeCheckbox(shwWA, 'WorkArea',2)">{{'Show Work Area' | translate | async}}</mat-checkbox>
            <mat-checkbox class="example-margin" [(ngModel)]="shwOb"  [checked]="shwOb"
                (change)="changeCheckbox(shwOb, 'Observer',6)"> {{'Show Observer' | translate | async}}</mat-checkbox>
        </div>
    </div>
</div>

<div>
    <button mat-raised-button color="warn"  style="float: right;margin-right: 2%;" (click)="DownloadCSVFile()"><span class="material-icons button__icon">save_alt</span></button>
    <mat-table class="table-material table-material--striped table-material--hover table-material--full-width" style="margin-left: 2%; margin-right: 2%;"
    #table [dataSource]="dataSource" matSort>

    <ng-container matColumnDef="CompletedDate">
        <mat-header-cell class="customWidthClass" *matHeaderCellDef mat-sort-header> {{'Date' | translate | async}}
        </mat-header-cell>
        <mat-cell class="customWidthClass" *matCellDef="let element" matTooltip="{{element.CompletedDate}}">
            <div > {{element.CompletedDate}} </div>
        </mat-cell>

    </ng-container>
    <ng-container matColumnDef="Department">
        <mat-header-cell class="customWidthClass" *matHeaderCellDef mat-sort-header> {{'Department' | translate | async}}
        </mat-header-cell>
        <mat-cell class="customWidthClass" *matCellDef="let element" matTooltip="{{element.Department}}">
            <div > {{element.Department}} </div>
        </mat-cell>

    </ng-container>
    <ng-container matColumnDef="WorkArea">
        <mat-header-cell class="customWidthClass" *matHeaderCellDef mat-sort-header> {{'Work Area' | translate | async}}
        </mat-header-cell>
        <mat-cell class="customWidthClass" *matCellDef="let element" matTooltip="{{element.WorkArea}}">
            <div> {{element.WorkArea}} </div>
        </mat-cell>

    </ng-container>

    <ng-container matColumnDef="Category">
        <mat-header-cell class="customWidthClass" *matHeaderCellDef mat-sort-header> {{"Category" | translate | async}}
        </mat-header-cell>
        <mat-cell class="customWidthClass" *matCellDef="let element" matTooltip="{{element.Category}}">
            <div >{{element.Category}} </div>
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="Question">
        <mat-header-cell class="customWidthClass" *matHeaderCellDef mat-sort-header> {{'Question' | translate | async}}
        </mat-header-cell>
        <mat-cell class="customWidthClass" *matCellDef="let element" matTooltip="{{element.Question}}">
            <div>{{element.Question}} </div>
        </mat-cell>
    </ng-container>
    <ng-container matColumnDef="SafeOrUnsafe">
        <mat-header-cell class="customWidthClass" *matHeaderCellDef mat-sort-header>{{"Safe/Unsafe" | translate | async}}
        </mat-header-cell>
        <mat-cell class="customWidthClass" *matCellDef="let element">
            <div >{{element.SafeOrUnsafe!=null?
                element.SafeOrUnsafe == 0?"Unsafe":element.SafeOrUnsafe == 1?"Safe":"N/A":""}} </div>
        </mat-cell>
    </ng-container>
    <ng-container matColumnDef="Observer">
        <mat-header-cell class="customWidthClass" *matHeaderCellDef mat-sort-header> {{'Observer' | translate | async}}
        </mat-header-cell>
        <mat-cell class="customWidthClass" *matCellDef="let element" matTooltip="{{element.Observer}}">
            <div> {{element.Observer}} </div>
        </mat-cell>
    </ng-container>


    <mat-header-row *matHeaderRowDef="displayedColumns; "></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns; "  (click)="onClickOpenInspection(row)" style="cursor: pointer;"></mat-row>
</mat-table>

    <div *ngIf="isLoading ==true" style="display: flex;flex-direction: column;align-items: center;
justify-content: center;min-height: 500px;align-self: center;">
        <mat-spinner></mat-spinner>
    </div>

    <div *ngIf="isLoading ==false && nodata"
        style="display: block;margin-left: 41%;font-size: larger;font-weight: bolder;">
        <span>{{'No Data Found for this search criteria.' | translate | async}}</span>
    </div>

</div>